<div class="bg-night">
  <k-info-panel
    [label]="'work_with_us' | translate"
    [bgColor]="'bg-night !text-neon'"
    [descColor]="'text-white'">
    <ng-container description>
      <p>{{ 'work_with_us_text' | translate }}</p>
      <br />
      <p>{{ 'work_with_us_text_2' | translate }}</p>
    </ng-container>

    <ng-container link>
      <div class="flex gap-4 justify-end">
        <a
          href="https://app.youform.com/forms/7zkzzcrc"
          target="_blank"
          rel="noopener"
          (click)="clickEvent('member-youform')">
          <div
            data-youform-open="8xky3ljv"
            data-youform-position="center"
            class="w-[150px] h-[150px] hover:motion-safe:animate-spin-slow cursor-pointer flex justify-center items-center transition ease-in-out">
            <img
              [src]="languageButtonLabelSig() === 'sk' ? '/images/clen-svk.svg' : '/images/clen-en.svg'"
              alt="Member application" />
          </div>
        </a>
        <a
          href="https://app.youform.com/forms/8xky3ljv"
          target="_blank"
          rel="noopener"
          (click)="clickEvent('volunteer-youform')">
          <div
            data-youform-open="8xky3ljv"
            data-youform-position="center"
            class="w-[150px] h-[150px] hover:motion-safe:animate-spin-slow cursor-pointer flex justify-center items-center transition ease-in-out">
            <img
              [src]="languageButtonLabelSig() === 'sk' ? '/images/dobrovolnik-svk.svg' : '/images/dobrovolnik_en.svg'"
              alt="Volunteer application" />
          </div>
        </a>
      </div>
    </ng-container>
  </k-info-panel>
</div>
